export default __webpack_public_path__ + "static/media/Schulung Homeoffice.c8d84282.jpg";